import { getMapSeries } from '../../widgets/map/getMapSeries';
import { IAlarmService, IGroupService, IGroupTreeHelperService } from '..';
import { ISeriesConfiguration } from '../../widgets';
import { getGroupGuidsOnMap } from '../../widgets/map/getGroupGuidsOnMap';

export interface IMapService {
    getSeries(): angular.IPromise<ISeriesConfiguration[]>;
}

export class MapService implements IMapService {
    static serviceId = 'mapService';

    static $inject = ['$q', 'groupService', 'alarmService', 'groupTreeHelperService'];

    constructor(
        private _$q: angular.IQService,
        private _groupService: IGroupService,
        private _alarmService: IAlarmService,
        private _groupTreeHelperService: IGroupTreeHelperService
    ) {}

    getSeries(): angular.IPromise<ISeriesConfiguration[]> {
        return this._$q.all([this._groupService.getAll(), this._alarmService.getAll()]).then((response) => {
            const groupDtos = response[0];
            const alarms = response[1];
            const groups = groupDtos.map((dto) => dto.group);
            const filteredGuids = getGroupGuidsOnMap(groups);
            const groupsOnMap = groups.filter((group) => filteredGuids.includes(group.guid));
            const allChildrenGroupsOnMap = groupsOnMap.flatMap((group) => this._groupTreeHelperService.getFlatChildren(groups, group.guid));
            const allGroupsToDisplay = groupsOnMap.concat(allChildrenGroupsOnMap);
            const series: ISeriesConfiguration[] = getMapSeries(allGroupsToDisplay, alarms);
            return series;
        });
    }
}
